import clsx from 'clsx';
import { formatCurrency } from '@budget/core';
import { getPersonName } from '../config/personNames';
import { useScope } from '../hooks/useScope';

export function PersonName({ person }: { person: 'dakota' | 'natalia' }) {
  return (
    <span className="person-chip">
      <span className={`person-dot ${person === 'dakota' ? 'dot-dakota' : 'dot-natalia'}`} />
      {getPersonName(person)}
    </span>
  );
}

export function PersonBreakdown({
  dakota,
  natalia,
  digits,
}: {
  dakota: number;
  natalia: number;
  digits?: number;
}) {
  const { scope } = useScope();
  const fmt = (n: number) => formatCurrency(n, 'USD', 'en-US', digits);
  // When the user scopes to a person, the non-scoped chip dims to 40% so the
  // active person reads as the focus. Household scope leaves both at full
  // opacity — neither is the "other".
  const dakotaDim = scope === 'natalia';
  const nataliaDim = scope === 'dakota';
  return (
    <div className="flex items-center gap-4 flex-wrap">
      <span
        className={clsx(
          'person-chip transition-opacity duration-150',
          dakotaDim && 'opacity-40',
        )}
      >
        <span className="person-dot dot-dakota" />
        <span>{getPersonName('dakota')}</span>
        <span className="tabular text-fg">{fmt(dakota)}</span>
      </span>
      <span
        className={clsx(
          'person-chip transition-opacity duration-150',
          nataliaDim && 'opacity-40',
        )}
      >
        <span className="person-dot dot-natalia" />
        <span>{getPersonName('natalia')}</span>
        <span className="tabular text-fg">{fmt(natalia)}</span>
      </span>
    </div>
  );
}
